  <template>
  <div class="po-released-container">
    <div v-if="!itemsLoaded" class="d-flex justify-content-center align-items-center chartContainer">
      <apexchart :type="chartOptions.xaxis.categories.length > 1 ? 'line' : 'scatter'" class="chart-box" height="275" :options="chartOptions" :series="series"></apexchart>
    </div>
    <b-table
      striped 
      bordered 
      :current-page="currentPage"
      :per-page="totalPerPage"
      no-border-collapse 
      responsive 
      :items="itemPO()" 
      :fields="fields" 
      head-variant="danger"
    >
      <template v-slot:cell(PO_TYPE)="data">
        <div class="type-container">
          {{ data.value }}
        </div>
      </template>

      <template v-slot:cell(PO_NUMBER)="data">
        <div class="number-container">
          {{ data.value }}
        </div>
      </template>

      <template v-slot:cell(TOTAL_VALUE_USD)="data">
        <div class="usd-container">
          <span class="usd-align">{{ curencyDelimiter(data.value) }}</span>
        </div>
      </template>

      <template v-slot:cell(TOTAL_VALUE_IDR)="data">
        <div class="idr-container">
          <span>{{ curencyDelimiter(data.value) }}</span>
        </div>
      </template>

      <template v-slot:cell(po_date)="data">
        <div class="date-container">
          {{ checkDate(data.value) }}
        </div>
      </template>
    </b-table>
    <div class="datatable-pagination-setting">
      <b-pagination
        aria-controls="isupplier-table"
        v-model="currentPage"
        :total-rows="itemPO().length"
        :per-page="totalPerPage"
        align="fill"
        class="my-0 page-button"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import numeral from 'numeral'
export default {
  name: 'POReleased',
  props: {
    detailId: {
      type: String,
      required: false // true if api ready
    }
  },
  data() {
    return {
      currentPage : 1,
      totalPerPage: 20,
      dateFormat: { day: 'numeric', month: 'short', year: 'numeric' },
      fields: [
        { key: 'PO_TYPE', label: 'PO Type', thClass: 'text-head bg-head' },
        { key: 'PO_NUMBER', label: 'PO Number' ,thClass: 'text-head bg-head'},
        { key: 'TOTAL_VALUE_USD', label: 'PO Value USD' ,thClass: 'text-head bg-head'},
        { key : 'TOTAL_VALUE_IDR', label : 'PO Value IDR', thClass: 'text-head bg-head'},
        { key: 'PO_DATE', label: 'PO Date',thClass: 'text-head bg-head' }
      ],
      items: [
        { PO_TYPE: 'Services', PO_NUMBER: '10001', TOTAL_VALUE_USD: 500000, TOTAL_VALUE_IDR : 6900000000, PO_DATE: 1562067992682 },
        { PO_TYPE: 'Construction', PO_NUMBER: '10002', TOTAL_VALUE_USD: 200000, TOTAL_VALUE_IDR : 2760000000, PO_DATE: 1570067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 800000, TOTAL_VALUE_IDR : 11040000000, PO_DATE: 1576067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 800000, TOTAL_VALUE_IDR : 11040000000, PO_DATE: 1577067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 800000, TOTAL_VALUE_IDR : 11040000000, PO_DATE: 1578067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 300000, TOTAL_VALUE_IDR : 4140000000, PO_DATE: 1579067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 500000, TOTAL_VALUE_IDR : 6900000000, PO_DATE: 1580067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 600000, TOTAL_VALUE_IDR : 8280000000, PO_DATE: 1581067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 700000, TOTAL_VALUE_IDR : 9660000000, PO_DATE: 1583067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 100000, TOTAL_VALUE_IDR : 1380000000, PO_DATE: 1585067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 700000, TOTAL_VALUE_IDR : 9660000000, PO_DATE: 1587067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 500000, TOTAL_VALUE_IDR : 6900000000, PO_DATE: 1589067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 300000, TOTAL_VALUE_IDR : 4140000000, PO_DATE: 1593067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 800000, TOTAL_VALUE_IDR : 11040000000, PO_DATE: 1596067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 900000, TOTAL_VALUE_IDR : 12420000000, PO_DATE: 1597067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 500000, TOTAL_VALUE_IDR : 6900000000, PO_DATE: 1598067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 800000, TOTAL_VALUE_IDR : 11040000000, PO_DATE: 1599067992682 },
        { PO_TYPE: 'Pengadaan', PO_NUMBER: '10003', TOTAL_VALUE_USD: 400000, TOTAL_VALUE_IDR : 5520000000, PO_DATE: 1601067992682 },
      ],
      chartOptions: {
        chart: {
          id : 'PO Value',
          toolbar : {
            show : false
          },
        },
        title : {
          text : 'PO Monthly',
          align : 'center'
        },
        xaxis: {
          categories: [],
          labels : {
            show : true
          }
        },
        yaxis: [{
          title: {
            text: 'PO Value USD',
          },
          labels : {
            formatter : (value) => { return this.curencyDelimiter(value)}
          }
        }, {
          opposite: true,
          title: {
            text: 'PO Value IDR'
          },
          labels : {
            formatter : value => { return this.curencyDelimiter(value)}
          }
        }]
      },
      series: [
        {
          name : 'PO Value USD',
          data: [],
        },
        {
          name : 'PO Value IDR',
          data: [],
        }
      ]
    }
  },
  computed: {
    itemsLoaded(){
      this.monthCategories()
      this.seriesData()
    }
  },
  methods: {
    checkDate(value){
      if(value && moment(value).isValid()){
        return moment(value).format('DD MMM YYYY')
      }
    },
    itemPO(){
      const self = this
      if(self.items){
        return self.items
      }
      return []
    },
    curencyDelimiter(value){
      if(value && value !== ''){
        let idr = numeral(value).format('0,0.00')
        let newIdr = ''
        idr.split('').map(list => {
          if(list == ','){
            newIdr += '.'
          } else if(list == '.') {
            newIdr += ','
          } else {
            newIdr += list
          }
        })
        return newIdr
      }
      return '-'
    },
    monthCategories(){
      const self = this
      const dateFormat = { month : 'short', year : 'numeric'}
      if(self.items){
        const items = self.items
  
        let data = {}
        for(let i in items){
          const event = new Date(items[i].PO_DATE).toLocaleString('en-GB', dateFormat)
          if(data[`${event}`] == undefined){
            data[`${event}`] = {
              'po_value' : items[i]['TOTAL_VALUE_USD'],
              'po_value_idr' : items[i]['TOTAL_VALUE_IDR']
            }
          } else {
            data[`${event}`] = {
              'po_value' : items[i]['TOTAL_VALUE_USD'] + data[`${event}`]['po_value'],
              'po_value_idr' : items[i]['TOTAL_VALUE_IDR'] + data[`${event}`]['po_value_idr'],
            }
          }
        }
        return data
      }
      return []
    },
    // monthCategories(){
    //   const self = this
    //   const dateFormat = { month : 'short', year : 'numeric'}
    //   if(self.$store.state.datatable.detail){
    //     const items = self.$store.state.datatable.detail.po
  
    //     let data = {}
    //     for(let i in items){
    //       const event = new Date(items[i].PO_DATE).toLocaleString('en-GB', dateFormat)
    //       if(data[`${event}`] == undefined){
    //         data[`${event}`] = {
    //           'po_value' : items[i]['TOTAL_VALUE_USD'],
    //           'po_value_idr' : items[i]['TOTAL_VALUE_IDR']
    //         }
    //       } else {
    //         data[`${event}`] = {
    //           'po_value' : items[i]['TOTAL_VALUE_USD'] + data[`${event}`]['po_value'],
    //           'po_value_idr' : items[i]['TOTAL_VALUE_IDR'] + data[`${event}`]['po_value_idr'],
    //         }
    //       }
    //     }
    //     return data
    //   }
    //   return []
    // },
    seriesData() {
      const self = this
      const po = Object.entries(self.monthCategories())
      let categories = []
      let po_value = []
      let po_value_idr = []
      po.forEach(list => {  
        categories.push(list[0])
        po_value.push(parseInt(list[1]['po_value']))
        po_value_idr.push(parseInt(list[1]['po_value_idr']))
      })
      
      self.chartOptions.xaxis.categories = categories
      self.series[0].data = po_value
      self.series[1].data = po_value_idr
    },
  }
}
</script>
<style lang="scss">
  @import "~/assets/scss/components/poReleased.scss";
</style>
